import React, { ReactNode } from 'react';
import './ApplicationTemplate.scss';
import { Navbar } from 'components/organisms';
import { Outlet } from 'react-router-dom';

const ApplicationTemplate = () => {
  return (
    <div className='application-template'>
      <div className='navbar'>
        <Navbar />
      </div>
      <div className='application'>
        <Outlet />
      </div>
    </div>
  );
};

export default ApplicationTemplate;
